export default function generalInit() {
	(function ($) {

		window.headerHeight = 76;
		window.scrollOffset = window.headerHeight;

		function myScrollTo($target, $trigger) {
			if ($target.length) {
				var offTop = $target.offset().top;

				if ($trigger.attr('data-ignore-header') === undefined) {

					offTop -= window.scrollOffset;

					if ($('[data-fixed-nav-menu]:visible').length) offTop -= $('[data-fixed-nav-menu]').outerHeight();

					// offTop -= $('#site-header').outerHeight();
					// offTop -= 40;
				}

				offTop = Math.ceil(offTop);

				var animationTime = 700;

				if ($trigger.attr('data-speed')) {
					animationTime = parseInt($trigger.attr('data-speed'));
				}
				if (!animationTime) {
					animationTime = Math.abs(offTop - $(window).scrollTop()) * 0.6;
				}

				$(window).trigger('smooth-scroll-started');

				$('html, body').stop().animate({ scrollTop: offTop }, animationTime, 'easeOutQuart', function () {
					$(window).trigger('smooth-scroll-ended');
				});
			}
		}

		$('a[href="#"]').click(function (e) {
			e.preventDefault();
		});

		$('a[data-smooth-scroll]').click(function (e) {

			var $target = $($(this).attr('href'));
			if (!$target.length) $target = $(this).closest('section').next('section');

			if ($target.length) e.preventDefault();

			myScrollTo($target, $(this));

		});

		$('a[href^="#"]:not([href="#"]):not([data-tabs-link])').click(function (e) {

			var $target = $($(this).attr('href'));
			if (!$target.length) return;

			e.preventDefault();
			myScrollTo($target, $(this));

		});

		//add simple support for background images:
		$(document).on('lazybeforeunveil', function (e) {
			var bg = $(e.target).attr('data-bg');
			if (bg) {
				e.target.style.backgroundImage = 'url(\'' + bg + '\')';
			}
		});

	})(jQuery);
}